/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDevicesByWeekResponseElements,
    ReportForDevicesByWeekResponseElementsFromJSON,
    ReportForDevicesByWeekResponseElementsFromJSONTyped,
    ReportForDevicesByWeekResponseElementsToJSON,
} from './ReportForDevicesByWeekResponseElements';

/**
 * 
 * @export
 * @interface ReportForDevicesByWeekResponse
 */
export interface ReportForDevicesByWeekResponse {
    /**
     * 
     * @type {Array<ReportForDevicesByWeekResponseElements>}
     * @memberof ReportForDevicesByWeekResponse
     */
    elements: Array<ReportForDevicesByWeekResponseElements> | null;
}

export function ReportForDevicesByWeekResponseFromJSON(json: any): ReportForDevicesByWeekResponse {
    return ReportForDevicesByWeekResponseFromJSONTyped(json, false);
}

export function ReportForDevicesByWeekResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDevicesByWeekResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': (json['elements'] === null ? null : (json['elements'] as Array<any>).map(ReportForDevicesByWeekResponseElementsFromJSON)),
    };
}

export function ReportForDevicesByWeekResponseToJSON(value?: ReportForDevicesByWeekResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': (value.elements === null ? null : (value.elements as Array<any>).map(ReportForDevicesByWeekResponseElementsToJSON)),
    };
}

